export default __webpack_public_path__ + "static/illustration-content.url-3efcb3b3c70d7bd1da2d9c47b4901bab.svg";